"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyDynamicCalculatorConfig = void 0;
exports.makeEmptyDynamicCalculatorConfig = function () {
    return {
        agencyId: '',
        description: '',
        profileConditions: [],
        renderConditions: [],
    };
};
//# sourceMappingURL=DynamicCalculatorRenderConfig.js.map